import type { Vote } from '@creator/sdk/modules/voting/voting.model';
import type { VotePayload } from '@creator/sdk/modules/voting/voting.service';
import creatorSdk from '@src/services/creator-sdk';
import type { Post } from '@src/store/contentEntities/model';

export async function vote(payload: VotePayload): Promise<{ post: Post }> {
    return creatorSdk.votingModule.vote(payload);
}

export async function loadVote(postId: string): Promise<Vote | null> {
    return creatorSdk.votingModule.getVote(postId);
}
